import React from "react";
import "./Education.css";
import { motion } from "framer-motion";

export default function Education() {
  return (
    <motion.div className="splitScreen"  animate={{ opacity: 1, scale: 1 }}
    transition={{
      duration: 1,
      delay: 0.1,
      ease: [0.2, 0.41, 0.91, 1 ],
    }}
    initial={{ opacity: 0, scale: 0.5}}
    >
      <div className="leftPane">
        <p className="titleText">Education</p>

        <div className="containerEduc" id="style2">
          <div className="courseTab">
            <img className="resp_img" src="rouen.png" width={40} height={40} />

            <p className="courseTitle">Université de Rouen Normandie</p>
            <p className="resp_txt">2022-2024</p>
            <p className="resp_txt">Master Ingénierie sur le logicielle</p>
          </div>
          <div className="courseTab">
            <img className="resp_img" src="mosta.png" width={40} height={40} />

            <p className="courseTitle">Université de Mostaganem</p>
            <p>2018-2021</p>
            <p>Licence en Système d'information</p>
          </div>
          <div className="courseTab">
            <img className="resp_img" src="cervantes.png" width={40} height={40} />

            <p className="courseTitle">Institut Cervantes</p>
            <p>2018-2019</p>
            <p>Formation en langue espagnol A2</p>
          </div>
        </div>
      </div>
      <div className="rightPane">
        <p className="titleText">Professional Experience</p>

        <div className="secondEducContainer">
          <div className="courseTab">
            <img className="resp_img" src="kio.png" width={50} height={50} />

            <a href="https://kiostore.net/">
              <p href="" className="courseTitle">
                Kiostore
              </p>
            </a>
            <p>2020-2021</p>
            <p>Développeur Fullstack</p>
          </div>
          <div className="courseTab">
            <img className="resp_img" src="dwaya.png" width={40} height={40} />
            <a href="https://dwayaofficine.com/">
              <p className="courseTitle">DwayaOfficine</p>
            </a>
            <p>2019-2021</p>
            <p>Développeur Fullstack</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
